import { STALE_TIME, GC_TIME, QUERY_PRESETS } from "@/queries/queryTimeConfig";

export const ratePlanApiConfig = {
  createRatePlan: {
    key: "createRatePlan",
    url: "/api/v1/rate-plans",
    method: "POST",
    options: {
      retry: 2,
      invalidateKeys: ["fetchRatePlans", "getRatePlan"],
      onSuccessMessage: "Rate plan created successfully",
      onErrorMessage: "Failed to create rate plan",
    },
  },

  getRatePlan: {
    key: "getRatePlan",
    url: (data) => `/api/v1/rate-plans/${data.id}`,
    method: "GET",
    options: {
      ...QUERY_PRESETS.DETAIL,
    },
  },

  fetchRatePlans: {
    key: "fetchRatePlans",
    url: "/api/v1/rate-plans",
    method: "GET",
    options: {
      ...QUERY_PRESETS.LIST,
    },
  },

  updateRatePlan: {
    key: "updateRatePlan",
    url: (data) => `/api/v1/rate-plans/${data.id}`,
    method: "PATCH",
    options: {
      retry: 2,
      invalidateKeys: ["fetchRatePlans", "getRatePlan"],
      onSuccessMessage: "Rate plan updated successfully",
      onErrorMessage: "Failed to update rate plan",
    },
  },

  deleteRatePlan: {
    key: "deleteRatePlan",
    url: (data) => `/api/v1/rate-plans/${data.id}`,
    method: "DELETE",
    options: {
      retry: 2,
      invalidateKeys: ["fetchRatePlans", "getRatePlan", "getDeletedRatePlans"],
      onSuccessMessage: "Rate plan deleted successfully",
      onErrorMessage: "Failed to delete rate plan",
    },
  },

  getDeletedRatePlans: {
    key: "getDeletedRatePlans",
    url: "/api/v1/rate-plans/deleted",
    method: "GET",
    options: { ...QUERY_PRESETS.LIST },
  },

  restoreRatePlan: {
    key: "restoreRatePlan",
    url: (data) => `/api/v1/rate-plans/${data.id}/restore`,
    method: "PATCH",
    options: {
      retry: 2,
      invalidateKeys: ["fetchRatePlans", "getRatePlan", "getDeletedRatePlans"],
      onSuccessMessage: "Rate plan restored successfully",
      onErrorMessage: "Failed to restore rate plan",
    },
  },
};
